export const scroll = () => {
    let lastScrollTop = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (currentScroll > 150) {
            if (currentScroll > lastScrollTop) {
                document.body.classList.add('hidden');
            }
            else if (currentScroll < lastScrollTop) {
                document.body.classList.remove('hidden');
            }
        } else {
            document.body.classList.remove('hidden');
        }

        lastScrollTop = currentScroll;
    });
}
